<template>
  <!-- 头部 -->
  <div class="top">
    <van-image
      width="3rem"
      height="3rem"
      fit="cover"
      round
      src="/image/v2_smru35.png"
    />
    <!-- <div>{{ title }}</div> -->
    <div class="content">
      <div class="title-top">预问诊</div>
      <div class="title-bottom">让医生更早了解您的病情</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CuHeader",
  props: {
    title: {
      type: String,
      default: "预问诊",
    },
  },
};
</script>
<style lang="less" scoped>
.top {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  font-size: 14px;
  font-weight: 600;
  height: 113px;
  padding: 15px 15px 0px;
  .content {
    margin-left: 6px;
    .title-top{
      margin-bottom: 10px;
      font-size: 28px;
      color: rgba(245,15,21,1);
    }
    .title-bottom{
      font-size: 20px;
      color: rgba(15, 64, 245, 1);
    }
  }
}
</style>
